import * as React from 'react';
import {
	chakra,
	ImageProps,
	forwardRef,
} from '@chakra-ui/react';
import logo from '../../Assets/svg/nike.svg';

export const NikeIcon = forwardRef<ImageProps, 'img'>((props, ref) => {
	return <chakra.img src={logo} ref={ref} {...props} />;
});